var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "stars-rating",
        "size_" + _vm.size,
        { interactive: _vm.interactive }
      ]
    },
    _vm._l(_vm.stars, function(star, index) {
      return _c("star", {
        key: index,
        attrs: { size: _vm.size, active: star, "error-mode": _vm.errorMode },
        nativeOn: {
          click: function($event) {
            return _vm.onClick(index)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }